import { IconProp } from '@fortawesome/fontawesome-svg-core';

import Comissioning from '~src/assets/nav-icons/commissioning-en.png';
import ControlDa from '~src/assets/nav-icons/control-da.png';
import ControlEn from '~src/assets/nav-icons/control-en.png';
import EconomicsDa from '~src/assets/nav-icons/economics-da.png';
import EconomicsEn from '~src/assets/nav-icons/economics-en.png';
import EnquieriesDa from '~src/assets/nav-icons/enquieries-da.png';
import EnquieriesEn from '~src/assets/nav-icons/enquieries-en.png';
import FacilityManagementDa from '~src/assets/nav-icons/facility-management-da.png';
import FacilityManagementEn from '~src/assets/nav-icons/facility-management-en.png';
import SupervisionDa from '~src/assets/nav-icons/supervision-da.png';
import SupervisionEn from '~src/assets/nav-icons/supervision-en.png';
import TasksDa from '~src/assets/nav-icons/tasks-da.png';
import TasksEn from '~src/assets/nav-icons/tasks-en.png';
import ModuleTender from '~src/assets/nav-icons/module-tender-hammer-color.svg';
import { LANGUAGE } from '~src/config';
import { LoadModulesReturnType } from '~src/services/api/modules';
import { MODULES } from '~src/types/enums';

export interface NavItemType {
  key: string;
  keyPath?: string;
  section: string;
  nameTerm: string;
  icon: IconProp;
  color: string;
  path?: string;
  id?: MODULES;
  moduleName?: keyof LoadModulesReturnType;
  customIcon?: string;
  isLeaf?: boolean;
}

/** Navigation items to be used on left navigation tree & home view */
const navigationItems: NavItemType[] = [
  {
    key: 'primary-svf-viewer',
    section: 'project-data',
    nameTerm: 'primary-svf-viewer',
    icon: ['fad', 'cubes'] as IconProp,
    color: 'blue',
    path: '/',
    isLeaf: true,
  },
  {
    key: 'archive',
    keyPath: 'archive',
    section: 'project-data',
    nameTerm: 'archive',
    icon: ['fad', 'archive'] as IconProp,
    color: 'blue',
    path: '/archive',
  },
  {
    key: 'tenders',
    keyPath: 'tenders',
    section: 'project-data',
    nameTerm: 'tender',
    icon: ['fad', 'folders'] as IconProp,
    color: 'lightBlue',
    path: '/tenders',
    customIcon: ModuleTender,
  },
  {
    key: 'recents',
    section: 'project-data',
    nameTerm: 'recent-files',
    icon: ['fad', 'inbox'],
    color: 'darkBlue',
    path: '/recents',
    isLeaf: true,
  },
  {
    key: 'favourites',
    section: 'project-data',
    nameTerm: 'favourites',
    icon: ['fad', 'star'],
    color: 'yellow',
    path: '/favourites',
    isLeaf: true,
  },
  {
    key: 'search',
    section: 'project-data',
    nameTerm: 'search',
    icon: ['far', 'search'],
    color: 'darkBlue',
    path: '/search',
    isLeaf: true,
  },
  {
    key: 'shared-with-me',
    section: 'project-data',
    nameTerm: 'shared-with-me',
    icon: ['fad', 'share-alt-square'],
    color: 'yellow',
    path: '/share',
    isLeaf: true,
  },
  {
    key: 'tasks',
    section: 'special',
    nameTerm: 'tasks',
    icon: ['fad', 'tasks-alt'],
    customIcon: LANGUAGE.startsWith('da') ? TasksDa : TasksEn,
    color: 'green',
    path: `/module/${MODULES.TASK}`,
    id: MODULES.TASK,
    moduleName: 'task',
    isLeaf: true,
  },
  {
    key: 'questions',
    section: 'special',
    nameTerm: 'questions',
    icon: ['fad', 'question-square'],
    customIcon: LANGUAGE.startsWith('da') ? EnquieriesDa : EnquieriesEn,
    color: 'darkGray',
    path: `/module/${MODULES.TQ}`,
    id: MODULES.TQ,
    moduleName: 'technical_question',
    isLeaf: true,
  },
  {
    key: 'supervision',
    section: 'special',
    nameTerm: 'supervision',
    icon: ['fad', 'box-usd'],
    customIcon: LANGUAGE.startsWith('da') ? SupervisionDa : SupervisionEn,
    color: 'green',
    path: `/module/${MODULES.SUPV}`,
    id: MODULES.SUPV,
    moduleName: 'supervision',
    isLeaf: true,
  },
  {
    key: 'control',
    section: 'special',
    nameTerm: 'control',
    icon: ['fad', 'sliders-h-square'],
    customIcon: LANGUAGE.startsWith('da') ? ControlDa : ControlEn,
    color: 'red',
    path: `/module/${MODULES.CONT}`,
    id: MODULES.CONT,
    moduleName: 'control',
    isLeaf: true,
  },
  {
    key: 'commisions',
    section: 'special',
    nameTerm: 'commisions',
    icon: ['fad', 'box-usd'],
    customIcon: Comissioning,
    color: 'green',
    path: `/module/${MODULES.COM}`,
    id: MODULES.COM,
    moduleName: 'commissioning',
    isLeaf: true,
  },

  {
    key: 'economics',
    section: 'special',
    nameTerm: 'economics',
    icon: ['fad', 'box-usd'],
    customIcon: LANGUAGE.startsWith('da') ? EconomicsDa : EconomicsEn,
    color: 'green',
    path: `/module/${MODULES.ECO}`,
    id: MODULES.ECO,
    moduleName: 'eco',
    isLeaf: true,
  },
  {
    key: 'facility-management',
    section: 'special',
    nameTerm: 'facility-management',
    icon: ['fad', 'box-usd'],
    customIcon: LANGUAGE.startsWith('da')
      ? FacilityManagementDa
      : FacilityManagementEn,
    color: 'green',
    path: `/module/${MODULES.DV}`,
    id: MODULES.DV,
    moduleName: 'd_and_v',
    isLeaf: true,
  },
];

/**
 * Get module navigation items based on user's module_file_admin permission
 *
 * All users see the old module entries (Tasks, TQ, etc.) based on module enabled status.
 * Users with module_file_admin ADDITIONALLY see the "Modules-Sectors" entry.
 *
 * @param hasModuleFileAdmin - Whether the user has module_file_admin permission
 * @returns Array of navigation items for the 'special' section
 */
export const getModuleNavigationItems = (
  hasModuleFileAdmin: boolean
): NavItemType[] => {
  // Old module items - shown to ALL users (filtered by module enabled status in ProjectLeftSideView)
  const oldModuleItems: NavItemType[] = [
    {
      key: 'tasks',
      section: 'special',
      nameTerm: 'tasks',
      icon: ['fad', 'tasks-alt'],
      customIcon: LANGUAGE.startsWith('da') ? TasksDa : TasksEn,
      color: 'green',
      path: `/module/${MODULES.TASK}`,
      id: MODULES.TASK,
      moduleName: 'task',
      isLeaf: true,
    },
    {
      key: 'questions',
      section: 'special',
      nameTerm: 'questions',
      icon: ['fad', 'question-square'],
      customIcon: LANGUAGE.startsWith('da') ? EnquieriesDa : EnquieriesEn,
      color: 'darkGray',
      path: `/module/${MODULES.TQ}`,
      id: MODULES.TQ,
      moduleName: 'technical_question',
      isLeaf: true,
    },
    {
      key: 'supervision',
      section: 'special',
      nameTerm: 'supervision',
      icon: ['fad', 'box-usd'],
      customIcon: LANGUAGE.startsWith('da') ? SupervisionDa : SupervisionEn,
      color: 'green',
      path: `/module/${MODULES.SUPV}`,
      id: MODULES.SUPV,
      moduleName: 'supervision',
      isLeaf: true,
    },
    {
      key: 'control',
      section: 'special',
      nameTerm: 'control',
      icon: ['fad', 'sliders-h-square'],
      customIcon: LANGUAGE.startsWith('da') ? ControlDa : ControlEn,
      color: 'red',
      path: `/module/${MODULES.CONT}`,
      id: MODULES.CONT,
      moduleName: 'control',
      isLeaf: true,
    },
    {
      key: 'commisions',
      section: 'special',
      nameTerm: 'commisions',
      icon: ['fad', 'box-usd'],
      customIcon: Comissioning,
      color: 'green',
      path: `/module/${MODULES.COM}`,
      id: MODULES.COM,
      moduleName: 'commissioning',
      isLeaf: true,
    },
    {
      key: 'economics',
      section: 'special',
      nameTerm: 'economics',
      icon: ['fad', 'box-usd'],
      customIcon: LANGUAGE.startsWith('da') ? EconomicsDa : EconomicsEn,
      color: 'green',
      path: `/module/${MODULES.ECO}`,
      id: MODULES.ECO,
      moduleName: 'eco',
      isLeaf: true,
    },
    {
      key: 'facility-management',
      section: 'special',
      nameTerm: 'facility-management',
      icon: ['fad', 'box-usd'],
      customIcon: LANGUAGE.startsWith('da')
        ? FacilityManagementDa
        : FacilityManagementEn,
      color: 'green',
      path: `/module/${MODULES.DV}`,
      id: MODULES.DV,
      moduleName: 'd_and_v',
      isLeaf: true,
    },
  ];

  // If user has module_file_admin permission, add Modules-Sectors entry at the beginning
  if (hasModuleFileAdmin) {
    return [
      {
        key: 'modules',
        section: 'special',
        nameTerm: 'moduls-sectors',
        icon: ['fad', 'map'] as IconProp,
        color: 'blue',
        // No path - clicking just expands/collapses the tree
        isLeaf: false,
      },
      ...oldModuleItems,
    ];
  }

  // Return only old modules for users without permission
  return oldModuleItems;
};

export const navigationItemsTimeMachine: NavItemType[] = [
  {
    key: 'archive',
    section: 'project-data',
    nameTerm: 'archive',
    icon: ['fad', 'archive'] as IconProp,
    color: 'blue',
    path: '/archive',
  },
  {
    key: 'search',
    section: 'project-data',
    nameTerm: 'search',
    icon: ['far', 'search'],
    color: 'darkBlue',
    path: '/search',
    isLeaf: true,
  },
];

export const navigationItemsMobile: NavItemType[] = [
  {
    key: 'primary-svf-viewer',
    section: 'project-data',
    nameTerm: 'primary-svf-viewer',
    icon: ['fad', 'cubes'] as IconProp,
    color: 'blue',
    path: '/',
  },
  {
    key: 'archive',
    section: 'project-data',
    nameTerm: 'archive',
    icon: ['fad', 'archive'] as IconProp,
    color: 'blue',
    path: '/archive',
  },
  {
    key: 'favourites',
    section: 'project-data',
    nameTerm: 'favourites',
    icon: ['fad', 'star'],
    color: 'yellow',
    path: '/favourites',
    isLeaf: true,
  },
  {
    key: 'tasks',
    section: 'special',
    nameTerm: 'tasks',
    icon: ['fad', 'tasks-alt'],
    customIcon: LANGUAGE.startsWith('da') ? TasksDa : TasksEn,
    color: 'green',
    path: `/module/${MODULES.TASK}`,
    id: MODULES.TASK,
    moduleName: 'task',
    isLeaf: true,
  },
  {
    key: 'questions',
    section: 'special',
    nameTerm: 'questions',
    icon: ['fad', 'question-square'],
    customIcon: LANGUAGE.startsWith('da') ? EnquieriesDa : EnquieriesEn,
    color: 'darkGray',
    path: `/module/${MODULES.TQ}`,
    id: MODULES.TQ,
    moduleName: 'technical_question',
    isLeaf: true,
  },
  {
    key: 'supervision',
    section: 'special',
    nameTerm: 'supervision',
    icon: ['fad', 'box-usd'],
    customIcon: LANGUAGE.startsWith('da') ? SupervisionDa : SupervisionEn,
    color: 'green',
    path: `/module/${MODULES.SUPV}`,
    id: MODULES.SUPV,
    moduleName: 'supervision',
    isLeaf: true,
  },
  {
    key: 'control',
    section: 'special',
    nameTerm: 'control',
    icon: ['fad', 'sliders-h-square'],
    customIcon: LANGUAGE.startsWith('da') ? ControlDa : ControlEn,
    color: 'red',
    path: `/module/${MODULES.CONT}`,
    id: MODULES.CONT,
    moduleName: 'control',
    isLeaf: true,
  },
  {
    key: 'commisions',
    section: 'special',
    nameTerm: 'commisions',
    icon: ['fad', 'box-usd'],
    customIcon: Comissioning,
    color: 'green',
    path: `/module/${MODULES.COM}`,
    id: MODULES.COM,
    moduleName: 'commissioning',
    isLeaf: true,
  },

  {
    key: 'economics',
    section: 'special',
    nameTerm: 'economics',
    icon: ['fad', 'box-usd'],
    customIcon: LANGUAGE.startsWith('da') ? EconomicsDa : EconomicsEn,
    color: 'green',
    path: `/module/${MODULES.ECO}`,
    id: MODULES.ECO,
    moduleName: 'eco',
    isLeaf: true,
  },
  {
    key: 'facility-management',
    section: 'special',
    nameTerm: 'facility-management',
    icon: ['fad', 'box-usd'],
    customIcon: LANGUAGE.startsWith('da')
      ? FacilityManagementDa
      : FacilityManagementEn,
    color: 'green',
    path: `/module/${MODULES.DV}`,
    id: MODULES.DV,
    moduleName: 'd_and_v',
    isLeaf: true,
  },
];

export enum BaseHomeNavigationKeys {
  HOME = 'home',
  CACHED_PUBLIC_TENDERS = 'public-tenders',
  CACHED_SHARES = 'invitations',
  PROJECTWEB = 'projectweb',
  MY_TENDERS = 'my-tenders',
}

export const navigationItemsHome: NavItemType[] = [
  {
    key: BaseHomeNavigationKeys.CACHED_PUBLIC_TENDERS,
    section: 'project-data',
    nameTerm: 'public-tenders',
    icon: ['fad', 'share-alt-square'] as IconProp,
    color: 'green',
    path: '/public-tenders',
  },
  {
    key: BaseHomeNavigationKeys.CACHED_SHARES,
    section: 'project-data',
    nameTerm: 'invitations',
    icon: ['fad', 'share-alt-square'] as IconProp,
    color: 'yellow',
    path: '/invitations',
  },
  {
    key: BaseHomeNavigationKeys.PROJECTWEB,
    section: 'project-data',
    nameTerm: 'projectweb',
    icon: ['fad', 'house'],
    color: 'darkBlue',
    path: '/my-projects',
  },
  {
    key: BaseHomeNavigationKeys.MY_TENDERS,
    keyPath: 'my-tenders',
    section: 'project-data',
    nameTerm: 'my-tender',
    icon: ['fad', 'folders'] as IconProp,
    color: 'lightBlue',
    path: '/my-tenders',
    customIcon: ModuleTender,
  },
];

export default navigationItems;
